// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import Notifications from 'react-notification-system-redux';
import styled from 'styled-components';

// shared components
import AppHeader from '../../components/shared/AppHeader';
import Nav from '../../components/shared/Nav';
import Section404 from '../../components/shared/Section404';
import Loader from '../../components/Loader/Loader';

// top level containers used via routes
import Contacts from '../Contacts/Contacts';
import ContactsAdd from '../ContactsAdd/ContactsAdd';
import ContactsEdit from '../ContactsEdit/ContactsEdit';
import ContactReassigns from '../ContactReassigns/ContactReassigns';
import ContactReassignsAdd from '../ContactReassignsAdd/ContactReassignsAdd';
import Dashboard from '../Dashboard/Dashboard';
import PropertyAdd from '../PropertyAdd/PropertyAdd';
import PropertyEdit from '../PropertyEdit/PropertyEdit';
import PropertySearch from '../PropertySearch/PropertySearch';
import Stations from '../Stations/Stations';
import StationsAdd from '../StationsAdd/StationsAdd';
import StationsEdit from '../StationsEdit/StationsEdit';
import PlasmaScreens from '../PlasmaScreens/PlasmaScreens';
import StandardText from '../StandardText/StandardText';
import Export from '../Export/Export';
import ToLetBoards from '../ToLetBoards/ToLetBoards';
import ContactRequests from '../ContactRequests/ContactRequests';
import ContactRequestView from '../ContactRequests/ContactRequestView';
import Login from '../Login/Login';

// always load shared data on root mount
import {
    loginWithLocalStorageToken,
    logout,
} from '../../redux/reducers/authentication';
import { getAuthToken } from '../../shared/utils';

const roles = {
    PROPERTY_MANAGER: 'property_manager',
    TO_LET_BOARDS: 'to_let_boards',
};

const StyledApp = styled.div`
    background: #edf1f2;
    height: 100vh;
`;

const AppWrapper = styled.div`
    height: calc(100vh - 79px);
    display: flex;
`;

const AppContent = styled.div`flex-grow: 1;`;

class App extends Component {
    onLogout: Function;

    constructor(props) {
        super(props);

        this.onLogout = this.onLogout.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        const existingToken = getAuthToken();

        if (existingToken && existingToken.length > 0) {
            dispatch(loginWithLocalStorageToken(existingToken));
        }
    }

    onLogout() {
        this.props.dispatch(logout());
    }

    render() {
        const {
            authentication,
            errorFetching,
            isFetching,
            finishedLoading,
            notifications,
        } = this.props;

        const role = authentication.authenticated
            ? authentication.user.userRole
            : '';

        const showLoginForm =
            authentication.authenticating || !authentication.authenticated;

        return (
            <StyledApp>
                <Notifications notifications={notifications} />

                <AppHeader />

                {isFetching &&
                    <Loader message="Initialising, please wait..." />}

                {errorFetching &&
                    <Loader message="Failed to initialise. Please try again." />}

                {showLoginForm && <Login />}

                {finishedLoading &&
                    authentication.authenticated &&
                    <AppWrapper>
                        <Nav
                            forenames={authentication.user.userForenames}
                            role={authentication.user.userRole}
                            onLogout={this.onLogout}
                        />

                        <AppContent>
                            <Switch>
                                <Route path="/" component={Dashboard} exact />

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/property"
                                        component={PropertySearch}
                                        exact
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/property/add"
                                        component={PropertyAdd}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/property/edit/:propertyReference/:section?"
                                        component={PropertyEdit}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contacts"
                                        component={Contacts}
                                        exact
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contacts/add"
                                        component={ContactsAdd}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contacts/edit/:contactId"
                                        component={ContactsEdit}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contacts/reassigns"
                                        component={ContactReassigns}
                                        exact
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contacts/reassigns/add"
                                        component={ContactReassignsAdd}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/stations"
                                        component={Stations}
                                        exact
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/stations/add"
                                        component={StationsAdd}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/stations/edit/:stationId"
                                        component={StationsEdit}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/plasma-screens"
                                        component={PlasmaScreens}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/standard-text"
                                        component={StandardText}
                                    />}

                                {(role === roles.PROPERTY_MANAGER ||
                                    role === roles.TO_LET_BOARDS) &&
                                    <Route
                                        path="/to-let-boards"
                                        component={ToLetBoards}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contact-requests/view/:contactRequestId"
                                        component={ContactRequestView}
                                    />}
                                {role === roles.PROPERTY_MANAGER &&
                                    <Route
                                        path="/contact-requests"
                                        component={ContactRequests}
                                    />}

                                {role === roles.PROPERTY_MANAGER &&
                                    <Route path="/export" component={Export} />}

                                <Route component={Section404} />
                            </Switch>
                        </AppContent>
                    </AppWrapper>}
            </StyledApp>
        );
    }
}

const mapStateToProps = state => {
    const authentication = state.authentication;
    const shared = state.shared;

    return {
        authentication,
        errorFetching: shared.error,
        isFetching: shared.fetching,
        finishedLoading: shared.finishedLoading,
        notifications: state.notifications,
    };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App/App.js